module.exports = __webpack_public_path__ + "img/smile.eadaabad.png";